import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React, { useRef } from 'react';
import { Text } from "../../Text/Text/Text";
import styles from "./HearOurMembersSlice.module.scss";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation } from 'swiper';
import { Button } from "../../Button/Button/Button";
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HearOurMembersSlice = function HearOurMembersSlice(_ref) {
  var items = _ref.items,
    _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    _ref$navigationButton = _ref.navigationButtons,
    navigationButtons = _ref$navigationButton === void 0 ? null : _ref$navigationButton,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? null : _ref$buttonProps;
  var swiperRef = useRef(null);
  var renderButton = function renderButton(classButton) {
    return buttonProps && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: classNames(styles.joinNow, classButton)
    }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.attributes) || {}), {}, {
      type: "primary",
      url: buttonProps.link,
      children: buttonProps.text
    }));
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.hearOurMembers,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.sliderContainer,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.container,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.headerContainer,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.headerText,
            children: /*#__PURE__*/_jsx(Text, {
              typog: "headline1",
              children: headerText
            })
          }), renderButton(styles.normalButton)]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.swiperWrapper,
          children: items && /*#__PURE__*/_jsx(Swiper, {
            slidesPerView: "auto",
            spaceBetween: 20,
            ref: swiperRef,
            modules: [Navigation, Mousewheel],
            className: styles.swiper,
            mousewheel: {
              forceToAxis: true
            },
            children: items.map(function (item, index) {
              return /*#__PURE__*/_jsx(SwiperSlide, {
                className: styles.swiperSlide,
                children: /*#__PURE__*/_jsxs("div", {
                  className: styles.item,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.imageWrapper,
                    children: /*#__PURE__*/_jsx("img", {
                      className: styles.image,
                      src: item.imageUrl,
                      alt: item.name
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.textWrapper,
                    children: /*#__PURE__*/_jsx("div", {
                      className: styles.text,
                      children: /*#__PURE__*/_jsxs("div", {
                        className: styles.textInner,
                        children: [/*#__PURE__*/_jsx(Text, {
                          typog: "captionSmall",
                          className: styles.testimonial,
                          children: item.text
                        }), /*#__PURE__*/_jsx("div", {
                          className: styles.testimonialName,
                          children: item.name
                        })]
                      })
                    })
                  })]
                })
              }, index);
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.navigation,
          children: [/*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
            onClick: function onClick() {
              var _swiperRef$current;
              return (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : _swiperRef$current.swiper.slidePrev();
            }
          }, (navigationButtons === null || navigationButtons === void 0 ? void 0 : navigationButtons.left) || {}), {}, {
            children: /*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "8",
              height: "14",
              viewBox: "0 0 8 14",
              fill: "none",
              children: /*#__PURE__*/_jsx("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.81576 2.04595C6.06472 1.79718 6.46835 1.79718 6.71732 2.04595C6.96628 2.29472 6.96628 2.69804 6.71732 2.94682L2.63476 7.02621L6.71732 11.1056C6.96628 11.3544 6.96628 11.7577 6.71732 12.0065C6.46835 12.2553 6.06472 12.2553 5.81576 12.0065L1.28242 7.47664C1.03346 7.22788 1.03346 6.82454 1.28242 6.57578L5.81576 2.04595Z",
                fill: "#070517"
              })
            })
          })), /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
            onClick: function onClick() {
              var _swiperRef$current2;
              return (_swiperRef$current2 = swiperRef.current) === null || _swiperRef$current2 === void 0 ? void 0 : _swiperRef$current2.swiper.slideNext();
            }
          }, (navigationButtons === null || navigationButtons === void 0 ? void 0 : navigationButtons.right) || {}), {}, {
            children: /*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "8",
              height: "14",
              viewBox: "0 0 8 14",
              fill: "none",
              children: /*#__PURE__*/_jsx("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2.18398 2.04595C1.93502 1.79718 1.53138 1.79718 1.28242 2.04595C1.03346 2.29472 1.03346 2.69804 1.28242 2.94682L5.36498 7.02621L1.28242 11.1056C1.03346 11.3544 1.03346 11.7577 1.28242 12.0065C1.53138 12.2553 1.93502 12.2553 2.18398 12.0065L6.71732 7.47664C6.96628 7.22788 6.96628 6.82454 6.71732 6.57578L2.18398 2.04595Z",
                fill: "#070517"
              })
            })
          }))]
        }), renderButton(styles.mobileButton)]
      })
    })
  });
};